import { Component, Injector, Input, OnInit } from "@angular/core";
import { BaseEntityComponent, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { Tranche } from "src/app/model/tranche.model";
import Utils from "src/app/shared/fgi-utils";
import { PermissaoService } from "src/app/shared/permissao.service";
import { TrancheService } from "src/app/shared/services/tranche.service";


@Component({
    selector: 'app-tranche-listagem',
    templateUrl: './tranche-listagem.component.html',
    styleUrls: ['./tranche-listagem.component.scss'],
    standalone: false
})
export class TrancheListaComponent extends BaseEntityComponent<Tranche> implements OnInit {

  @Input() public tranches: Tranche[] = [];
  atributosOrdenacao: EntityOrderedRequestParameters;
  public podeCadastrarTranche: boolean = false;




  // override
  constructor(
    protected injector: Injector,
    protected trancheService: TrancheService,
    private permissaoService: PermissaoService,



  ) {
    super(trancheService);
    this.config.bloquearTelaAoRecuperarModelo = true;
    this.model = new Tranche();
  }

  //Ordenação
  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }
  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.tranches = this.tranches.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.compara(a, b, ord.atributo);
      }
      else {
        return -1 * Utils.compara(a, b, ord.atributo);
      }
    });
  }

  habilitarTipoCalculoLimite(){
    return true
  }
  ngOnInit(): void {
    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches;
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeCadastrarTranche = resp && resp[ROLE_GESTOR_ENVIO];
    });

    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }

}


